// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_I8w0IBvBO",
  aws_user_pools_web_client_id: "4eu9bndlt3f927gnrkosh6t80f",
  oauth: {
    domain: "apps-skfilluminate.auth.us-east-1.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    redirectSignIn: "https://apps.skfilluminate.net",
    redirectSignOut: "https://apps.skfilluminate.net",
    responseType: "code"
  },
  federationTarget: "COGNITO_USER_POOLS"
};


 export default awsmobile;


